/* import {
  MessageBox
} from 'element-ui'

var ElementMessage = MessageBox
var EL_MESSAGE_DEFAULT = {
  duration: 5000,
  showClose: true,
  customClass: 'my-el-message-font'
}
ElementMessage = function (options) {
  if (typeof (options) === 'object') {
    options = Object.assign({}, EL_MESSAGE_DEFAULT, options)
  }
  MessageBox(options)
}

export default ElementMessage
 */

import { Toast } from 'mint-ui'

var MINT_TOAST_DEFAULT = {
  duration: 3000,
  type: 'success',
  showClose: true
}
var MintToast = function (options) {
  if (typeof (options) === 'object') {
    options = Object.assign({}, MINT_TOAST_DEFAULT, options)
  }
  Toast(options)
}

export default MintToast



// WEBPACK FOOTER //
// ./src/third/Message.js